export function createRedirectUrl(id, module) {
    return `http://crm.snoopconsulting.com/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3D${module}%26offset%3D1%26stamp%3D1594739619077055300%26return_module%3DOpportunities%26action%3DDetailView%26record%3D${id}`;
}